import { ValidationObserver, ValidationProvider } from "vee-validate";
import UserService from "../../services/user/UserService";
import i18n from "../../i18n";

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    data() {
        return {
            hasError: false,
            identificationType: null,
            identification: null,
            name: null,
            email: null,
            password: null,
            passwordConfirmation: null,
            imageIdentificationFront: null,
            imageIdentificationBack: null,
            identificationTypes: [],
            loading: false,
            isShowModal: false,
            closemodal: false,
        };
    },
    computed: {
        isDisabled() {
            return (!this.identificationType ||
                !this.identification ||
                !this.name ||
                !this.email ||
                !this.password ||
                !this.passwordConfirmation ||
                !this.imageIdentificationBack ||
                !this.imageIdentificationFront
            );
        },
    },

    created() {
        this.getDocuments();
    },

    methods: {
        deleteDropFile(type) {
            if (type === "front") this.imageIdentificationFront = null;
            if (type === "back") this.imageIdentificationBack = null;
        },

        async getDocuments() {
            try {
                const response = await UserService.documentTypes();
                this.identificationTypes = response.data;
            } catch (error) {
                this.showToast("Error consultando los tipos de documento", "is-warning");
            }
        },
        numero() {
            this.identification = ""
        },
        onlyNumberAndLetters(e) {
            if (e.key.match(/[a-zñçáéíóú\s]/i) === null) {
                e.preventDefault();
            }
        },
        onlyNumber(e) {
            if (this.identificationType == 'CC' | this.identificationType == 'TI' || this.identificationType == 'NI' || this.identificationType == 'NU') {

                if (e.key.match(/[0-9\s]/i) === null) {
                    e.preventDefault();
                }
            } else {
                if (e.key.match(/[a-z0-9\s]/i) === null) {
                    e.preventDefault();
                }
            }

        },
        filterKey(e) {
            const key = e.key;
            if (/[A-Za-z- ]/.test(key)) console.log("Positivo");
            else return e.preventDefault();
        },

        async register() {
            //this.isShowModal = true;


            try {
                this.email = this.email.toLowerCase();
                this.name = this.name.toUpperCase();

                const formData = new FormData();

                formData.append("identificationType", this.identificationType);
                formData.append("identification", this.identification);
                formData.append("name", this.name);
                formData.append("email", this.email);
                formData.append("password", this.password);
                formData.append("cellPhone", this.cellPhone);
                formData.append("imageIdentificationBack", this.imageIdentificationBack);
                formData.append("imageIdentificationFront", this.imageIdentificationFront);

                var passReg = /^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,16}$/;
                var passValido = passReg.test(this.password);
                if (passValido == true && this.password == this.passwordConfirmation) {
                    var expReg = /\w+@\w+\.+[a-z]/;
                    var esValido = expReg.test(this.email);
                    if (esValido == true) {
                        const response = await UserService.register(formData);
                        const data = this.identification
                        if (response.data.status == "NEW") {
                            this.isShowModal = true;
                        }

                    } else {

                        this.showToast(
                            "El correo ingresado no es valido, verifica los datos",
                            "is-danger"
                        );
                    }

                } else {
                    this.showToast(
                        "La Contraseña debe ser igual, tener entre 8 y 16 caracteres, almenos una mayuscula y una minuscula, porfavor verifica los datos",
                        "is-danger"
                    );
                }

            } catch (error) {
                if (error.data == "User already requested") {
                    this.isShowModal = false;
                    this.$buefy.toast.open({
                        message: "El paciente ya cuenta con un registro",
                        type: "is-danger",
                    });

                } else {
                    this.$buefy.toast.open({
                        message: error.data,
                        type: "is-danger",
                    });
                }
            }
        },

        showToast(message, type) {

            this.$buefy.toast.open({ message, type, duration: "5000" });
        },
        NumText(string) { //solo letras y numeros
            return string.toUpperCase();
        }
    },
};
